@if (isOpen()) {
  <div class="toolbox-debug">
    <button class="toolbox-close" (click)="isOpen.set(false)">✕</button>
    <code>
      {{ 'changed:' + formState().dirty }}<br />
      {{ 'untouched:' + formState().untouched }}<br />
      {{ 'valid:' + formState().valid }}<br />
      {{ 'enabled:' + formState().enabled }}
    </code>
    <button (click)="getLiveFormRequested.emit()">
      {{ translateService.instant('liveforms-editor.debug.get-live-form') }}
    </button>
    <button (click)="getXmlRequested.emit()">
      {{ translateService.instant('liveforms-editor.debug.get-xml') }}
    </button>
    <button (click)="getFormattedXmlRequested.emit()">
      {{ translateService.instant('liveforms-editor.debug.get-formatted-xml') }}
    </button>
  </div>
} @else {
  <button class="toolbox-tab" (click)="isOpen.set(true)">
    <mat-icon>home_repair_service</mat-icon>
  </button>
}
